/* ───────────────────────────────────────────────────────────────────────────
   cabecera-fija-co.js — LA ÚNICA MEDIDA QUE EL CSS NO PUEDE TOMAR SOLO.

   Qué hace: publica en el documento la altura de la cabecera en sus DOS estados
   (`--cab-alta` arriba del todo, `--cab-baja` ya compactada). Nada más. Ninguna
   decisión, ningún estilo, ninguna clase: quien pinta es skin-tienda-co.css y
   quien decide cuándo compactar es el propio tema.

   POR QUÉ EXISTE, que es la parte que importa. La cabecera se fija con
   `position: sticky`, y un elemento sticky **sigue ocupando su hueco en el
   flujo**. Si al compactarse pasa de 161 px a 62 px, el documento se acorta 99 px
   y TODO lo que hay debajo salta hacia arriba de golpe, en plena lectura. Se
   compensa devolviendo esos px como `margin-bottom` (en el CSS), pero para eso
   hay que saber cuánto miden los dos estados… y no es un número fijo:
   medido en la tienda viva, la alta va de 132 px (320 px de ancho, el logo no
   cabe y el tema lo encoge) a 161 (móvil normal), 277 (990 px, el menú en línea
   se parte en dos renglones) y 228 (1280). Hard-codearlo por breakpoints sería
   adivinar, y se rompería el día que alguien añada una entrada al menú.

   🔒 SE MIDE EN UNA SOLA TAREA SÍNCRONA (quitar clases → leer → poner clase →
   leer → restaurar). El navegador no pinta a mitad de una tarea, así que el
   usuario nunca ve el estado intermedio.

   🔒 SE MIDE SIN REDONDEAR. Con `Math.round` en las dos alturas el error se
   acumulaba y quedaba 1 px de salto en escritorio (medido). Con el valor
   fraccionario el salto es 0 en los 10 anchos probados.

   Se re-mide cuando cambia algo que pueda alterar la altura: al terminar de
   cargar (el logo puede llegar tarde), al rotar o redimensionar, y cuando el
   editor de temas vuelve a montar la sección.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var CLASES = ['shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate'];

  /* Cuánto hay YA pegado arriba por encima de nosotros. En esta tienda la app
     «Essential» deja su barra de «Pago contra entrega…» en `position: sticky;
     top: 0` con z-index 101 — es suya y es ANTERIOR a este cambio, así que no se
     toca: la cabecera se apila DEBAJO. Se mide en vez de escribir un 60, porque
     la barra la edita el dueño desde el panel de la app y su alto cambia con el
     texto y con el ancho de pantalla. */
  function desplazamiento() {
    var sec = document.getElementById('shopify-section-header');
    var suma = 0;
    var todos = document.body.querySelectorAll('*');
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      // Solo lo que está ANTES de la cabecera en el documento; lo de después no
      // se apila encima de ella.
      if (!(sec.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
      if (sec.contains(el) || el.contains(sec)) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      if (parseFloat(cs.top) !== 0) continue;
      var alto = el.getBoundingClientRect().height;
      if (alto > 0) suma += alto;
    }
    return suma;
  }

  function medir() {
    var sec = document.getElementById('shopify-section-header');
    if (!sec) return;

    // Se guarda la lista de clases TAL CUAL para restaurarla intacta: el tema (y
    // alguna app) pueden haber puesto clases suyas que no nos incumben.
    var original = sec.className;

    var i;
    for (i = 0; i < CLASES.length; i++) sec.classList.remove(CLASES[i]);
    var alta = sec.getBoundingClientRect().height;

    sec.classList.add('shopify-section-header-sticky');
    var baja = sec.getBoundingClientRect().height;

    sec.className = original;

    // Si algo devuelve 0 (sección oculta, aún sin maquetar) NO se publica nada:
    // es preferible quedarse sin compensación —que a lo sumo deja un salto, el
    // defecto de antes— que publicar un margen absurdo y descuadrar la página.
    if (!alta || !baja || baja > alta) return;

    var raiz = document.documentElement.style;
    raiz.setProperty('--cab-alta', alta + 'px');
    raiz.setProperty('--cab-baja', baja + 'px');
    raiz.setProperty('--cab-desplazamiento', desplazamiento() + 'px');
  }

  var pendiente;
  function medirLuego() {
    clearTimeout(pendiente);
    pendiente = setTimeout(medir, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', medir);
  } else {
    medir();
  }
  // El logo es una imagen: hasta que carga, la altura puede no ser la definitiva.
  window.addEventListener('load', medir);
  window.addEventListener('resize', medirLuego);
  window.addEventListener('orientationchange', medirLuego);
  // El editor de temas re-monta la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', medirLuego);
  document.addEventListener('shopify:section:unload', medirLuego);
})();
